import { useState, useEffect } from "react"
import { useUpdateHepExerciseMutation, useDeleteHepExerciseMutation } from "./hepexercisesApiSlice"
import { useNavigate } from "react-router-dom"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSave, faTrashCan } from "@fortawesome/free-solid-svg-icons"
import { toast } from 'react-toastify'



const EditHepExerciseForm = ({ hepexercise, exercises }) => {

	const [updateHepExercise, {
		isSuccess,
		isError,
		error
	}] = useUpdateHepExerciseMutation()

	const [deleteHepExercise, {
		isSuccess: isDelSuccess,
		isError: isDelError,
		error: delerror
	}] = useDeleteHepExerciseMutation()

	const navigate = useNavigate()


	const [exercise_id, setExerciseId] = useState(hepexercise.exercise_id._id)
	const [id] = useState(hepexercise.id)
	const [hep_id, setHepId] = useState(hepexercise.hep_id)
	const [description, setDescription] = useState(hepexercise.description)

	useEffect(() => {
		if (isSuccess) {
			setExerciseId('')
			setDescription('')
			setHepId('')
			toast.success("Exercise was Updated");
			navigate(`/dash/hep/${hep_id}`)
		}

		if (isDelSuccess) {
			setExerciseId('')
			setDescription('')
			setHepId('')
			toast.success("Exercise was Deleted");
			navigate(`/dash/hep/${hep_id}`)
		}

		if (isError) {
			toast.error(error?.data?.message);
		}

		if (isDelError) {
			toast.error(delerror?.data?.message);
		}


	}, [isSuccess, isDelSuccess, navigate, isError, isDelError, error, delerror, hep_id])

	const onExerciseIdChanged = e => setExerciseId(e.target.value)
	const onDescriptionChanged = e => setDescription(e.target.value)

	let canSave
	canSave = [description.length].every(Boolean)


	const onSaveExerciseClicked = async (e) => {
		e.preventDefault()
		if (canSave) {
			await updateHepExercise({ id, exercise_id, hep_id, description })
		} else {
			toast.error('All Fields are Required');
		}
	}

	const onDeleteExerciseClicked = async () => {
		await deleteHepExercise({ id })
	}

	const options = exercises.map(exercise => {
		return (
			<option key={exercise.id} value={exercise.id}>
				{exercise.exercise_name}
			</option >
		)
	})

	let content
	content = (
		<section id="main_content">
			<header>
				<h1 className="text-steel mt-5">
					Edit Exercise for HEP
				</h1>
			</header>
			<main>
				<form onSubmit={e => e.preventDefault()}>
					<div className="row mb-3">
						<div className="col-md-6">
							<label className="form-label" htmlFor="exercise_id">
								Exercise:
							</label>
							<select
								id="exercise_id"
								name="exercise_id"
								className="form-select"
								value={exercise_id}
								onChange={onExerciseIdChanged}
							>
								{options}
							</select>
						</div>
					</div>
					<div className="row mb-3">
						<div className="col-md-6">
							<label className="form-label" htmlFor="exercise_details">
								Details:
							</label>
							<textarea
								className="form-control"
								id="description"
								rows="5"
								name="text"
								value={description}
								onChange={onDescriptionChanged}
							/>
						</div>
					</div>

					<div className="row mb-3">
						<div className="col-md-6 text-end">
							<span
								role="button"
								className="p-2 text-success icon"
								title="Save"
								onClick={onSaveExerciseClicked}
							>
								Update Exercise
								<FontAwesomeIcon icon={faSave} style={{ marginLeft: '5px' }} />
							</span>
							<span
								role="button"
								className="p-2 text-danger icon"
								title="Delete"
								onClick={onDeleteExerciseClicked}
							>
								Delete
								<FontAwesomeIcon icon={faTrashCan} style={{ marginLeft: '5px' }} />
							</span>
						</div>
					</div>
				</form>
			</main>
		</section>

	)

	return content



}

export default EditHepExerciseForm